module.exports = __webpack_public_path__ + "media/images/icon_pencil_yellow-7d7ee6cfd0a82ce9c2b35bf8382c27d2.png";